import React, { useState } from 'react';
import { AxiosError } from 'axios';
import { ITransactionUserSummary, IEventSummary } from '@eagerdog/interfaces';
import { Constants } from '@eagerdog/constants';

import { apiService } from 'src/services/api.service';
import { toast } from 'src/components/Toast/ToastManager';
import Button from 'src/components/Button/Button';
import Dropdown from 'src/components/Dropdown/Dropdown';
import Input from 'src/components/Input/Input';

import styles from './TransactionsTab.module.scss';

interface IProps {
  transaction: ITransactionUserSummary;
  event: IEventSummary;
  eventId: string;
  onPaid(): void;
  onCancel(): void;
}

interface IOption {
  value: string;
  id: string;
}

const paymentOptions: IOption[] = [
  { value: 'Cash', id: Constants.payment_method_type.cash },
  { value: 'Cheque', id: Constants.payment_method_type.cheque },
  { value: 'E-Transfer', id: Constants.payment_method_type.etransfer },
  { value: 'Other', id: Constants.payment_method_type.other },
];

const MarkAsPaidModal: React.FC<IProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<IOption>(paymentOptions[0]);
  const [chequeNumber, setChequeNumber] = useState('');

  const handleMarkPaid = async () => {
    setLoading(true);
    try {
      await apiService.markTransactionAsPaid(props.eventId, props.transaction._id, {
        payment_method_type: paymentMethod.id,
        cheque_number: paymentMethod.id === Constants.payment_method_type.cheque ? chequeNumber : undefined,
      });
      toast.show({
        title: 'Mark as Paid',
        content: 'Transaction marked as paid and registration created successfully.',
        duration: 5000,
        type: 'success',
      });
      props.onPaid();
    } catch (e: any) {
      toast.show({
        title: 'Mark as Paid',
        content: e.response?.data?.message || 'Something went wrong. Please try again.',
        duration: 8000,
        errorDetails: e as AxiosError,
        type: 'fail',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.markAsPaidModal}>
      <div className={styles.modalTitle}>Mark as Paid</div>
      <p className={styles.modalSubtitle}>
        Select the payment method received and confirm to create all registration records for this entry.
      </p>
      <div className={styles.modalFields}>
        <Dropdown
          label="Payment Method"
          value={paymentMethod}
          options={paymentOptions}
          onChange={(_e: any, val: IOption) => setPaymentMethod(val)}
          placeholder=""
        />
        {paymentMethod.id === Constants.payment_method_type.cheque && (
          <Input
            label="Cheque Number"
            type="text"
            value={chequeNumber}
            onChange={(e) => setChequeNumber(e.target.value)}
          />
        )}
      </div>
      <div className={styles.modalActions}>
        <Button className={styles.cancelBtn} onClick={props.onCancel} disabled={loading}>Cancel</Button>
        <Button onClick={handleMarkPaid} isLoading={loading}>Confirm Payment</Button>
      </div>
    </div>
  );
};

export default MarkAsPaidModal;
